import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './LeftNav.css';

const LeftNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const navItems = [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: '📊',
      path: '/dashboard'
    },
    {
      id: 'marketplace',
      label: 'Marketplace',
      icon: '🛒',
      path: '/marketplace',
      description: 'Browse brands'
    },
    {
      id: 'tryon',
      label: 'Virtual Try-On Studio',
      icon: '✨',
      path: '/tryon'
    },
    {
      id: 'accessories',
      label: 'Accessories Try-On',
      icon: '💎',
      path: '/accessories',
      description: 'Try watches, jewelry & more'
    },
    {
      id: 'models',
      label: 'Models',
      icon: '👤',
      path: '/models',
      description: 'Your model albums'
    },
    {
      id: 'collections',
      label: 'Collections Album',
      icon: '🌟',
      path: '/collections',
      description: 'Seasonal collections'
    },
    {
      id: 'favorites',
      label: 'My Favorites',
      icon: '❤️',
      path: '/favorites',
      description: 'Favorited brands'
    },
    {
      id: 'boutique',
      label: 'My Boutique',
      icon: '👔',
      path: '/boutique',
      description: 'Your personal fashion feed'
    },
    ...(user?.is_merchant ? [
      {
        id: 'merchant-divider',
        divider: true,
        label: 'Merchant'
      },
      {
        id: 'merchant',
        label: 'Merchant Dashboard',
        icon: '🏪',
        path: '/merchant'
      },
      {
        id: 'brands',
        label: 'My Brands',
        icon: '🏢',
        path: '/merchant/brands'
      },
      {
        id: 'products',
        label: 'My Products',
        icon: '📦',
        path: '/merchant/products'
      },
      {
        id: 'consumers',
        label: 'My Consumers',
        icon: '👥',
        path: '/merchant/consumers'
      },
      {
        id: 'campaign-analytics',
        label: 'Campaign Analytics',
        icon: '📊',
        path: '/merchant/campaigns',
        description: 'View campaign performance'
      },
      {
        id: 'create-campaign',
        label: 'Create Campaign',
        icon: '📧',
        path: '/merchant/campaigns/create',
        description: 'Send personalized try-ons to consumers'
      },
      {
        id: 'instore',
        label: 'In-Store Mode',
        icon: '🏬',
        path: '/merchant/instore'
      }
    ] : []),
    {
      id: 'settings',
      label: 'Settings',
      icon: '🔧',
      path: '/settings'
    },
    {
      id: 'shares',
      label: 'Recent Shares',
      icon: '📤',
      path: '/shares',
      badge: 'Soon'
    },
    {
      id: 'landing',
      label: 'Landing Page',
      icon: '🏠',
      path: '/'
    }
  ];

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <nav className="left-nav">
      <div className="left-nav-header">
        <div className="nav-logo" onClick={() => navigate('/')}>
          <img 
            src="https://customer-assets.emergentagent.com/job_5570680c-3f90-44c2-8f62-b2c05e92211c/artifacts/6tbkty9m_FITTTY-LOGO.png" 
            alt="FITTTY.AI" 
            className="logo-image"
          />
          <span className="logo-text">FITTTY.AI</span>
        </div>
      </div>

      <div className="nav-items">
        {navItems.map((item) => {
          if (item.divider) {
            return (
              <div key={item.id} className="nav-divider">
                <span>{item.label}</span>
              </div>
            );
          }
          
          return (
            <div
              key={item.id}
              className={`nav-item ${isActive(item.path) ? 'active' : ''} ${item.badge ? 'disabled' : ''}`}
              onClick={() => !item.badge && navigate(item.path)}
            >
              <span className="nav-icon">{item.icon}</span>
              <div className="nav-content">
                <span className="nav-label">{item.label}</span>
                {item.description && (
                  <span className="nav-description">{item.description}</span>
                )}
              </div>
              {item.badge && (
                <span className="nav-badge">{item.badge}</span>
              )}
            </div>
          );
        })}
      </div>

      <div className="nav-footer">
        <div className="nav-footer-text">
          <span className="version">Version 1.0</span>
          <span className="copyright">© 2024 FITTTY.AI</span>
        </div>
      </div>
    </nav>
  );
};

export default LeftNav;
